import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { ModalContext, useGlobalStore } from '../../../components/contexts';
import ValidateService from '../../../services/ValidateService';

import { useNavigate } from 'react-router-dom';
import GbitGrid from '../../../components/gridComponents/GbitGrid';
import InputText from '../../../components/inputComponents/InputText';
import ExpertAuditController from '../../../controllers/expert/register/ExpertAuditController';

const ExpertList = () => {
  const navigate = useNavigate();
  const { store } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const gridRef = useRef(null);

  const [valueObj, setValueObj] = useState({});
  const [selectOption, setOption] = useState([]);

  const [userInfo, setUserInfo] = useState({});

  const controller = useMemo(() => {
    return new ExpertAuditController(
      store,
      modalService,
      validateService,
      [gridRef],
      {
        valueObj,
        setValueObj,
      },
      {
        selectOption,
        setOption,
      },
      {
        userInfo,
        setUserInfo,
      },
      navigate
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    document.title = '전문가 심사 목록';
    if (controller.getRole()) {
      controller.fnSearch().then();
      controller.fnOption().then();
    } else {
      navigate('/');
    }
  }, []);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">전문가 심사 목록</h2>
      </div>
      <div id="search-box" className="section">
        <div className="section__body">
          <div className="sch-option">
            <dl className="sch-option__item">
              <dt>요청자</dt>
              <dd>
                <div className="input__wrap">
                  <InputText
                    id="userNm"
                    model="userNm"
                    value={valueObj}
                    isReadonly={false}
                    phValue={'요청자'}
                    changeEvt={(model, value) => {
                      controller.valueObjChange(model, value);
                    }}
                  />
                </div>
              </dd>
            </dl>
            <dl className="sch-option__item">
              <dt>상태</dt>
              <dd>
                <div className="input__select">
                  <select
                    aria-label="상태 선택"
                    name="filter"
                    className="form-select sm"
                    onChange={e => {
                      const { name, value } = e.target;
                      controller.valueObjChange(name, value);
                    }}
                  >
                    <option value="">전체</option>
                    {selectOption.map((item, i) => (
                      <option key={i} value={item.comCd}>
                        {item.comCdNm}
                      </option>
                    ))}
                  </select>
                </div>
              </dd>
            </dl>
          </div>
          <div className="btn-group">
            {store.authrtId !== 'ADMIN' &&
              userInfo.srngRsltCd !== 'C' &&
              userInfo.srngRsltCd !== 'P' && (
                <button
                  type="button"
                  className="btn sm"
                  onClick={() => controller.btnClick()}
                >
                  신청
                </button>
              )}
            <button
              type="button"
              className="btn sm"
              onClick={() => controller.fnSearch()}
            >
              검색
            </button>
          </div>
        </div>
      </div>
      <div className="section section-table">
        <GbitGrid
          ref={gridRef}
          id="expertAuditList"
          modalService={modalService}
          cellDblClick={(row, col, rowData) =>
            controller.gridCellDblClick(row, col, rowData)
          }
          caption="전문가 심사 목록의 No, 소속명, 요청자, 요청일자, 심사종료일자, 상태의 정보를 나타내는 표입니다."
          callback={controller.gridCallback}
        />
      </div>
    </>
  );
};

export default ExpertList;
